import { Controller } from '@hotwired/stimulus'

/**
 * Minimal controller for assignee dropdown search.
 * Most functionality is handled by Turbo Frames and Turbo Streams.
 */
export default class extends Controller {
  connect() {
    // Any initialization if needed
  }

  disconnect() {
    // Cleanup if needed
  }
}
